import { render, staticRenderFns } from "./BasicCard.vue?vue&type=template&id=381cdae5&scoped=true&"
import script from "./BasicCard.vue?vue&type=script&lang=ts&"
export * from "./BasicCard.vue?vue&type=script&lang=ts&"
import style0 from "./BasicCard.vue?vue&type=style&index=0&id=381cdae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cdae5",
  null
  
)

export default component.exports